import * as ActionTypes from "./ActionTypes";

export const setInvoices = (data) => ({
  type: ActionTypes.SET_INVOICES_LIST_REQUEST,
  data,
});
